import type { UserCredentials } from '@smartsash/api-client';
import { openModal } from '@smartsash/ui';

import CredentialsPanel from './CredentialsPanel';

import type { Translate } from '@/utils/translate';

/**
 * Show the one-time credentials and resolve once the admin has dismissed them.
 *
 * `dismissible: false` and `showClose: false` are load-bearing rather than stylistic: the
 * temporary password is unrecoverable (HS-1224), so a stray Escape or a misplaced click must not
 * be able to throw it away. The single explicit action is the only way out.
 */
export async function openCredentialsModal(
  credentials: UserCredentials,
  t: Translate,
  title: string,
): Promise<void> {
  await openModal({
    title,
    variant: 'warning',
    dismissible: false,
    showClose: false,
    body: <CredentialsPanel credentials={credentials} />,
    actions: [{ label: t('users.credentials.done'), value: 'done' }],
  }).closed;
}
